import { useEffect } from 'react';
import { useAiAgent } from '@/contexts/AiAgentContext';
import type { AiPageContext } from '@/utils/aiPageContextFromPath';

/**
 * Pushes explicit document context into the AI layer while this page is mounted
 * (overrides URL-only inference). Use on detail pages for accurate "this order" behavior.
 */
export function AiPageContextSync(props: Partial<AiPageContext> & { docId?: string }) {
  const { setPageContextOverride } = useAiAgent();
  const { module, docType, docId, filters } = props;
  useEffect(() => {
    setPageContextOverride({ module, docType, docId, filters });
    return () => setPageContextOverride(null);
  }, [setPageContextOverride, module, docType, docId, filters]);
  return null;
}
